<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="topicName" :label="$t('话题名称')">
<!--        <span slot="label">
          <a-tooltip>
            话题名称<template slot="title">话题名称</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.topicName" :maxLength="100" :placeholder="$t('请输入')+$t('话题名称')" >
          <locale-field-button
            slot="suffix"
            v-model="form.localeFieldMap['topicName']"
            :disabled="!form.topicName"
            input-type="input"
            table-name="discovery_topic"
            table-field="topicName"
            :field-value="form.topicName"
          />
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="channelId" :label="$t('频道名称')">
<!--        <span slot="label">
          <a-tooltip>
            频道名称<template slot="title">频道名称</template>
          </a-tooltip>
        </span>-->
        <a-select v-model="form.channelId" :placeholder="$t('请选择')" allow-clear>
          <a-select-option v-for="(item) in channelList" :value="item.id" :key="item.id">{{ $t(item.name) }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="sort"  :label="$t('排序')">
<!--        <span slot="label">
          <a-tooltip>
            排序<template slot="title">排序</template>
          </a-tooltip>
        </span>-->
        <a-input-number style="width: 100%;" v-model="form.sort" :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item prop="isRecommend" :label="$t('推荐')">
<!--        <span slot="label">
          <a-tooltip>
            推荐<template slot="title">推荐</template>
          </a-tooltip>
        </span>-->
        <a-select v-model="form.isRecommend" :placeholder="$t('请选择')" allow-clear>
          <a-select-option :value="true">{{$t('是')}}</a-select-option>
          <a-select-option :value="false">{{$t('否')}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="isEnabled" :label="$t('状态')">
<!--        <span slot="label">
          <a-tooltip>
            状态<template slot="title">状态</template>
          </a-tooltip>
        </span>-->
        <a-switch v-model="form.isEnabled"></a-switch>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDiscoveryTopic, addDiscoveryTopic, updateDiscoveryTopic } from '@/api/discovery/discoveryTopic'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { listDiscoveryChannelCategory } from '@/api/discovery/discoveryChannelCategory'
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    LocaleFieldButton,
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        topicName: null,

        channelId: null,

        useCount: null,

        sort: null,

        isRecommend: null,

        isEnabled: null,
        localeFieldMap : {},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        topicName: [
          { required: true, message: '话题名称' + this.$t('不能为空'), trigger: 'blur' }
        ],
        channelId: [
          { required: true, message: '频道名称' + this.$t('不能为空'), trigger: 'blur' }
        ],
        useCount: [
          { required: true, message: '使用次数' + this.$t('不能为空'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序' + this.$t('不能为空'), trigger: 'blur' }
        ],
        isRecommend: [
          { required: true, message: '推荐' + this.$t('不能为空'), trigger: 'blur' }
        ],
        isEnabled: [
          { required: true, message: '状态' + this.$t('不能为空'), trigger: 'blur' }
        ]
      },
      channelList: [],
      channelMap: {}
    }
  },
  filters: {},
  created() {
    this.getChannelList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    getChannelList() {
      listDiscoveryChannelCategory({ isEnabled: true }).then(res => {
        this.channelList = res.data
        for (const _item of res.data) {
          this.channelMap[_item.id] = _item.name
        }
      })
    },
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        topicName: null,
        channelId: null,
        useCount: 0,
        sort: 1,
        isRecommend: false,
        isEnabled: true,
        localeFieldMap : {},
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDiscoveryTopic({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateDiscoveryTopic(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addDiscoveryTopic(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
